import '@babel/polyfill';

import './flip';
import './slider';
import './modal';
import './accordion';
import './smooth-scroll';
import homeMore from './_homeMore';
import './fade';

if($('#js-list_more').length){
	homeMore()
}

